export enum SKILL_PRACTICE_TYPES {
  vocabulary = 4,
  listening,
  pronunciation
}
